// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-0b69bc38]{box-sizing:border-box;font-family:sans-serif;margin:0;padding:0}.flip-book-container[data-v-0b69bc38],body[data-v-0b69bc38],html[data-v-0b69bc38]{height:100vh;width:100%}.flip-book-container[data-v-0b69bc38]{overflow:hidden}iframe[data-v-0b69bc38]{border:none;height:100%;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
